<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="definitions">
<h1>Definitions</h1>
<p>It would be useful before Chapter One to give a list of accurate definitions as science has become so muddled that many words have lost their meaning, so a list of clear definitions to which the reader can refer is very important.</p>
<ol style="list-style-type: none">
<li><strong>1) Newtonian Mechanics</strong></li>
</ol>
<p class="pad">The simple set of deterministic rules to which matter behaves.</p>
<ol style="list-style-type: none">
<li><strong>2) Classical Mechanics</strong></li>
</ol>
<p class="pad">The analogue behaviour of matter. Planets move continuously through space, so it is analogue behaviour as opposed to quantum behaviour which is digital. In the quantum world, matter only exists and moves in precise quanta relative to other quanta; relative to space however, atomic particles show analogue behaviour.</p>
<ol style="list-style-type: none">
<li><strong>3) General Relativity</strong></li>
</ol>
<p class="pad">The explanation why bodies in space move, so it is very important to understand that bodies do not attract each other via an intrinsic ‘force’. Space and matter distort each other into mathematical forms, and bodies are ‘forced’ to follow the form space takes. General Relativity is the relationship between bodies and space, not bodies with each other.</p>
<ol style="list-style-type: none">
<li><strong>4) Special Relativity</strong></li>
</ol>
<p class="pad">The explanation of the relationship between units of energy with no mass (radiation) and space.</p>
<p style="padding-left: 15px;margin-left:20px;text-indent:0em;">These two relationships are two manifestations of the same thing, and this is expressed in E = mc<sup>2</sup>, mass and radiation can be changed into each other.</p>
<ol style="list-style-type: none">
<li><strong>5) Quantum Mechanics</strong></li>
</ol>
<p class="pad">The non-physical behaviour of matter. An electron moves continuously in a magnetic field but jumps from one electron orbital of an atom to another. Atomic entities show classical and quantum behaviour, entities bigger than the Planck Mass only show classical behaviour.</p>
<ol style="list-style-type: none">
<li><strong>6) Chaos</strong></li>
</ol>
<p class="pad">A fundamental behaviour of matter which has a definite mathematical fingerprint for the collective behaviour of systems. Each individual event is unpredictable, but if you graph many events, the graphs are governed by two mathematical values, the Feigenbaum Constants. The collective behaviour is deterministic; the individual behaviour is not. In classical mechanics, the individual behaviour and the outcomes are deterministic.</p>
<ol style="list-style-type: none">
<li><strong>7) Nonlinear Dynamics</strong></li>
</ol>
<p class="pad">Any behaviour which is not deterministic. The self-assembly of systems like snowflakes cannot be determined by looking at water molecules but is clearly not chaos. The confusion at the minute is caused by the fact that chaos and other kinds of nonlinear behaviour cannot be explained by predictable physics, so they are clumped together as non-deterministic or unpredictable.</p>
<ol style="list-style-type: none">
<li><strong>8) Complexity</strong></li>
</ol>
<p class="pad">Specifically refers to the behaviour of self-organising systems and requires the feedback of information into the system.</p>
<ol style="list-style-type: none">
<li><strong>9) The Collapse of the Wave Function.</strong></li>
</ol>
<p class="pad">A particle sitting in space does not behave as an individual unit of energy but as a wave of energy described by the Schrodinger Equation. If you try to detect where the particle is, the wave collapses to a position which cannot be predicted at the individual event, but collectively all the positions of points fit well-defined probabilities, so the behaviour of quantum entities flips over from deterministic to probabilistic.</p>
<ol style="list-style-type: none">
<li><strong>10) Physics</strong></li>
</ol>
<p class="pad">The combination of classical behaviour and quantum behaviour. Physics cannot explain any of the self-organising or chaotic properties of matter.</p>
<ol style="list-style-type: none">
<li><strong>11) Chemistry</strong></li>
</ol>
<p class="pad">The self-organising behaviour of molecules; this is not explained by the underlying laws of physics.</p>
<ol style="list-style-type: none">
<li><strong>12) Biology</strong></li>
</ol>
<p class="pad">The behaviour of molecules and bodies which evolve and optimise their position within the environment. This is the most complex behaviour of matter and uses all the fundamental kinds of behaviour which conspire together to produce complex systems which conserve information and evolve into new more sophisticated systems.</p>
<ol style="list-style-type: none">
<li><strong>13) Entropy</strong></li>
</ol>
<p class="pad">The measure of disorder in a system, and under the traditional viewpoint, this can only increase because there are no laws in classical physics to explain an increase in order or complexity.</p>
<ol style="list-style-type: none">
<li><strong>14) Quantum Gravity</strong></li>
</ol>
<p class="pad">The idea that space can be broken down into irreducible units.</p>
<ol style="list-style-type: none">
<li><strong>15) String Theory</strong></li>
</ol>
<p class="pad">The idea that matter can be reduced to loops of energy which can vibrate at different frequencies, producing the impression we get of different particles.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?488e011a